export default {
  state: () => ({
    deviceList: [],
    camerasLoaded: false,
    deviceSelected: 0,
    currentlyCachedOnvif: null,
  }),

  mutations: {
    cachedOnvifDevice(state, payload) {
      state.currentlyCachedOnvif = payload;
    },
    selectDevice(state, payload) {
      state.deviceSelected = payload;
    },
    addDevices(state, devices) {
      state.deviceList = devices;
      state.camerasLoaded = true;
    },

  },
  actions: {
    clearCachedOnvifDevice({ commit }) {
      // calls mutation in index.js
      commit('onvifSearch', null);
    },
    cachedOnvifDevice({ commit }, payload) {
      commit('cachedOnvifDevice', payload);
    },
    selectDevice({ commit }, payload) {
      commit('selectDevice', payload);
    },
  },
  getters: {
    cameraListAll(state) {
      const list = [];
      state.deviceList.forEach((device) => {
        list.push(...device.cameras);
      });
      return list;
    },

    camera: (state, getters) => (id) => getters.cameraListAll.find((camera) => camera.id === id),
    device: (state) => (name) => state.deviceList.find((device) => device.name === name),
    deviceId: (state) => (id) => state.deviceList.find((device) => device.id === id),
    deviceFind: (state) => (cameraId) => {
      let device;
      state.deviceList.forEach((element) => {
        element.cameras.forEach((camera) => {
          if (camera.id === cameraId) {
            device = element;
          } return 'no';
        });
      });
      return device;
    },

  },

};
